import { render, staticRenderFns } from "./PostFitOutComments.vue?vue&type=template&id=0d6f17da&scoped=true&"
import script from "./PostFitOutComments.vue?vue&type=script&lang=js&"
export * from "./PostFitOutComments.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutComments.vue?vue&type=style&index=0&id=0d6f17da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f17da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6f17da')) {
      api.createRecord('0d6f17da', component.options)
    } else {
      api.reload('0d6f17da', component.options)
    }
    module.hot.accept("./PostFitOutComments.vue?vue&type=template&id=0d6f17da&scoped=true&", function () {
      api.rerender('0d6f17da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutComments.vue"
export default component.exports